import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatePipeModule } from 'libraries/date/date.module';
import { ButtonModule } from "libraries/module/formbuilder/fields/button/button.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { IdentityInfoEditorComponent } from "libraries/component/identity-info-editor/identity-info-editor.component";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { IdentityInfoModule } from "libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-detail/components/identity-info/identity-info.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { GetIdentityInfoPipe } from 'libraries/component/identity-info-editor/get-identity-info.pipe';
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";

@NgModule({
    imports: [
        CommonModule,
        DatePipeModule,
        ButtonModule,
        FormsModule,
        BtnModule,
        TextModule,
        DateModule,
        IdentityInfoModule,
        MatInputModule,
        MatRadioModule,
        ReactiveFormsModule,
        PermissionModule,
        ComboboxFieldModule,
    ],
    exports: [
        IdentityInfoEditorComponent,
        GetIdentityInfoPipe
    ],
    declarations: [
        IdentityInfoEditorComponent,
        GetIdentityInfoPipe,
    ],
})
export class IdentityInfoEditorModule { }
